import styles from "./BookingCalendarPopup.module.scss";
import React from "react";
import leftArrow from "../../../../assets/images/icons/arrow-left.svg";
import lineForClose from "../../../../assets/images/icons/line.svg";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {IClassEventReservation} from "../../../../models/ClassEventReservation";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import {$clientApi} from "../../../../http";
import {openMessage} from "../../../../store/notification/notificationSlice";
import CustomButton from "../../../../components/UI/CustomButton/CustomButton";
import {getImageFromAuthServer} from "../../../../helpers/image.helper";

interface IBookingCalendarPopup {
    reservation: IClassEventReservation,
    setShowDescriptionReservation: (value: {
        isOpen: boolean,
        reservation: IClassEventReservation | null
    }) => void,
    getClassEvents: () => void
}

const BookingCalendarPopup: React.FC<IBookingCalendarPopup> = ({
                                                                   reservation,
                                                                   setShowDescriptionReservation,
                                                                   getClassEvents
                                                               }) => {

    const dispatch = useAppDispatch();
    const {t} = useTranslation();


    const closePopup = () => {
        setShowDescriptionReservation({isOpen: false, reservation: null});
    }

    const cancelAppointment = async () => {
        const response = await $clientApi.post(`api/appointments/cancel/${reservation.id}`, reservation);
        if (response.status === 200) {
            closePopup();
            dispatch(openMessage({type: "success", title: t("AppointmentCancelSuccessfully")}));
            getClassEvents();
        } else {
            closePopup();
            dispatch(openMessage({type: "error", title: t("SomethingWentWrong")}));
        }
    }

    const cancelClass = async () => {
        if (reservation.dropinReservations?.length) {
            const response = await $clientApi.post(`api/drop-in/register-user/${reservation.dropinReservations[0].id}?api_version=2022-11-15`, {});
            if (response.status) {
                closePopup();
                dispatch(openMessage({type: "success", title: t("DropInReservationCancelSuccessfully")}));
                getClassEvents();
            } else {
                closePopup();
                dispatch(openMessage({type: "error", title: t("SomethingWentWrong")}));
            }
        } else if (reservation.reservations.length) {
            const response = await $clientApi.delete(`api/class-events/register-user/${reservation.reservations[0].id}`);
            if (response.status) {
                closePopup();
                dispatch(openMessage({type: "success", title: t("ReservationCancelSuccessfully")}));
                getClassEvents();
            } else {
                closePopup();
                dispatch(openMessage({type: "error", title: t("SomethingWentWrong")}));
            }
        } else if (reservation.waitingList?.length) {
            const response = await $clientApi.delete(`api/class-events/register-user/${reservation.waitingList[0].id}`);
            if (response.status) {
                closePopup();
                dispatch(openMessage({type: "success", title: t("WaitingListReservationCancelSuccessfully")}));
                getClassEvents();
            } else {
                closePopup();
                dispatch(openMessage({type: "error", title: t("SomethingWentWrong")}));
            }
        }
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.popup}>
                <div className={styles.close}>
                    <button onClick={closePopup} className={styles.btn}>
                        <img className={styles.desctop} src={leftArrow} alt={"close"}/>
                        <img className={styles.mobile} src={lineForClose} alt={"close"}/>
                    </button>
                </div>
                <div className={styles.content}>
                    <div className={styles.contentBox}>
                        <div className={styles.image}>
                            <img
                                src={reservation.type === "reservation" && reservation.cover ? getImageFromAuthServer(reservation.cover) : getImageFromAuthServer(reservation.trainingCourseImage)}
                                alt={"class"}/>
                        </div>
                        <div className={styles.row}>
                            <h3 className={styles.nameEvent}>{reservation.trainningCourseName}</h3>
                            <p className={styles.timeEvent}>{moment(reservation.occuranceDate).format("DD MMMM, HH:mm")}</p>
                        </div>

                        <h4 className={`${styles.title}`}>{t("Description")}</h4>
                        <p className={styles.text}>{reservation.description}</p>

                        <div className={styles.info}>
                            <div className={styles.item}>
                                <h3 className={styles.title}>{t("Duration")}</h3>
                                <p className={styles.text}>{reservation.duration} (minutes)</p>
                            </div>
                            <div className={styles.item}>
                                <h3 className={styles.title}>{t("Instructor")}</h3>
                                <p className={styles.text}>{reservation.instructorFirstName} {reservation.instructorLastName}</p>
                            </div>
                            {
                                reservation.type !== "reservation" && <div className={styles.item}>
                                <h3 className={styles.title}>{t("RoomCapacity")}</h3>
                                <p className={styles.text}>{reservation.capacity}</p>
                              </div>
                            }
                            {
                                reservation.type !== "reservation" && <div className={styles.item}>
                                <h3 className={styles.title}>{t("CancellationPolicy")}</h3>
                                <p className={styles.text}>{reservation.cancellationPolicy}</p>
                              </div>
                            }
                            <div className={styles.item}>
                                <h3 className={styles.title}>{t("SessionsDeducted")}</h3>
                                <p className={styles.text}>{reservation.credits}</p>
                            </div>
                            {
                                reservation.type !== "reservation" && <div className={styles.item}>
                                <h3 className={styles.title}>{t("SpaceLeft")}</h3>
                                <p className={styles.text}>{reservation.spaceLeft}</p>
                              </div>
                            }
                        </div>
                        {new Date(reservation.occuranceDate) > new Date() && <>
                            {
                                reservation.type !== "reservation" ?
                                    <CustomButton
                                        text={t("CancelClass")}
                                        type={"button"}
                                        typeStyle={"outline"}
                                        borderRadius={false}
                                        blueForOutline={true}
                                        functionOnClick={cancelClass}
                                    />
                                    :
                                    <CustomButton
                                        text={t("CancelAppointment")}
                                        type={"button"}
                                        typeStyle={"outline"}
                                        borderRadius={false}
                                        blueForOutline={true}
                                        functionOnClick={cancelAppointment}
                                    />
                            }
                        </>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookingCalendarPopup;